var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2045 0.329505C8.64384 -0.109835 9.35616 -0.109835 9.7955 0.329505C10.201 0.735049 10.2322 1.37318 9.88908 1.81451L9.7955 1.9205L3.84173 7.875H16.875C17.4963 7.875 18 8.37868 18 9C18 9.57694 17.5657 10.0524 17.0062 10.1174L16.875 10.125H3.84173L9.7955 16.0795C10.201 16.485 10.2322 17.1232 9.88908 17.5645L9.7955 17.6705C9.38995 18.076 8.75182 18.1072 8.31049 17.7641L8.2045 17.6705L0.329952 9.79594L0.329505 9.7955C0.221386 9.68738 0.139875 9.56273 0.0849706 9.42968C0.0302146 9.29729 0 9.15217 0 9C0 8.84738 0.0303903 8.70186 0.0854499 8.56916C0.123139 8.47812 0.173295 8.39103 0.235918 8.31049L0.23663 8.30968C0.265474 8.27262 0.296587 8.2374 0.32976 8.20425M8.2045 0.329505L0.32976 8.20425L8.2045 0.329505Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.d46d7442ca0c32107e81ffc4ae5b4ceb.svg";
export { ForwardRef as ReactComponent };